import requestV2 from '@/service/request-v2'
import { normalizePageResult } from '@/service/adapters/page-result'
import type { PageQuery, PageResult } from '@/types/crud'

export interface CertificateFilters {
  name: string
}

export interface CertificateRecord {
  id: number | string
  name: string
  ip: string
  certificate: string
  endTime: string | null
  aliAccount: string
}

export interface CertificatePayload {
  name: string
  ip: string
  certificate: string
  endTime?: string | null
  aliAccount: string
}

export async function fetchCertificatePage(
  query: PageQuery<CertificateFilters>,
  signal: AbortSignal
): Promise<PageResult<CertificateRecord>> {
  const payload = await requestV2.get<unknown>({
    url: '/main/certificate/queryByCondition',
    params: {
      ...query.filters,
      pageNo: query.pageNo,
      pageSize: query.pageSize
    },
    signal
  })
  return normalizePageResult<CertificateRecord>(payload)
}

export function createCertificate(payload: CertificatePayload) {
  return requestV2.post<void>({
    url: '/main/certificate/add',
    data: payload
  })
}

export function updateCertificate(
  id: CertificateRecord['id'],
  payload: CertificatePayload
) {
  return requestV2.put<void>({
    url: `/main/certificate/${id}`,
    data: payload
  })
}

export function deleteCertificate(id: CertificateRecord['id']) {
  return requestV2.delete<void>({
    url: `/main/certificate/${id}`
  })
}
